import { paths } from 'data/routes';

import { Button } from 'components/Button';
import { Filters } from 'components/Filters';
import { Table } from 'components/Table';

import { useList } from './List.hooks';

export function List(): React.ReactElement {
  const {
    userColumns,
    usersDataMapped,
    isLoading,
    filters,
    reset,
    register,
    handleSubmit,
    control,
    onSubmit,
    setValue,
    params,
  } = useList();

  return (
    <>
      <Filters
        reset={reset}
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        filters={filters}
        type="users"
        control={control}
        setValue={setValue}
        isLoading={isLoading}
        defaultValues={params}
      >
        <Button
          fontFamily="LFT Zeno Condensed"
          iconLeft="FiPlus"
          scale="lg"
          asLink
          to={paths.newUser}
          motive="addNew"
        >
          Create User
        </Button>
      </Filters>

      <Table
        tableName="users"
        isLoading={isLoading}
        columns={userColumns}
        data={usersDataMapped}
        hasPagination
      />
    </>
  );
}
